module.exports = __webpack_public_path__ + "img/logo-sf-solo.1d2b4181.svg";